import '@fullcalendar/core'
import router from '@router'
import store from '@state/store'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'dayjs/locale/es'
import ElementPlus, { dayjs } from 'element-plus'
import locale from 'element-plus/es/locale/lang/es'
import { createApp } from 'vue'
import Vue3Toastify from 'vue3-toastify'

import 'vue3-toastify/dist/index.css'
import App from './app.vue'
import './design/element-variables.scss'
import i18n from './locale/index'
import './design/_global.scss'

dayjs.locale('es') // Necessary for showing datePickers starting on monday on Element+

const app = createApp(App)
app.use(Vue3Toastify, {
  autoClose: 10000,
})
app.use(ElementPlus, { locale })
// app.use(ElementPlus)
app.use(store)
app.use(router)
app.use(i18n)

// vue-i18n v11 removed `$tc`; keep a compatibility alias for legacy templates.
if (typeof app.config.globalProperties.$tc !== 'function') {
  app.config.globalProperties.$tc = (...args) => i18n.global.t(...args)
}

// Global Filters
app.config.globalProperties.$filters = {
  capitalize(value) {
    if (!value) return ''
    value = value.toString()
    const arr = value.split(' ')
    const capitalizedArray = []
    arr.forEach((word) => {
      const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
      capitalizedArray.push(capitalized)
    })
    return capitalizedArray.join(' ')
  },
}

app.mount('#app')
